import * as Types from '@crimeos-frontend/crime-os/graphql';

import { gql } from '@apollo/client';
import { ComplaintFragmentDoc } from '@crimeos-frontend/crime-os/graphql-docs';
import * as Apollo from '@apollo/client';
export type ConvertToFirMutationVariables = Types.Exact<{
  params: Types.ConvertToFirParams;
}>;


export type ConvertToFirMutation = { __typename: 'Mutation', convertToFir: { __typename: 'Complaint', complaintId: number, complaintNumber: string, complaintType: Types.ComplaintType, formattedComplaintNumber: string, hasFinancialLoss: boolean, sectionOfLaw: string, isDraft: boolean, year: number, record: { __typename: 'Record', recordId: string, templateId: string, createdAt: string, fields: Array<{ __typename: 'FieldResponse', fieldId: string, fieldResponseId: string, systemFieldEnum?: Types.SystemFieldEnum | null, response?: { __typename: 'BaseUser', userId: string, profilePicUrl?: string | null, email?: string | null, userName?: string | null } | { __typename: 'GQLDateTimeType', dateTime?: string | null } | { __typename: 'GQLDateType', dateValue?: string | null } | { __typename: 'GQLFloatType', floatValue?: number | null } | { __typename: 'GQLIntType', integerValue?: number | null } | { __typename: 'GQLListStringType', values: Array<string> } | { __typename: 'GQLStringType', stringValue?: string | null } | { __typename: 'GQLTimeType', timeValue?: string | null } | { __typename: 'LookupResponseType', lookupResponses: Array<{ __typename: 'LookupResponse', label: string, value: string }> } | { __typename: 'PhoneNumberResponse', dialCode: string, iso2CountryCode?: string | null, phoneNumber: string } | { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number } | null } | null>, handleDetailsWithGroups?: { __typename: 'HandleDetailsWithGroups', handleDetails: { __typename: 'HandleDetails', recordId: string, templateId: string, title: string, description?: string | null, logoUrl?: string | null, isBookmarked: boolean, pendingActions: Array<{ __typename: 'HandlePendingAction', handlePendingActionId: string, sectionType: Types.HandleSectionTypeEnum, name: string, count: number }> }, groups: Array<{ __typename: 'HandleGroup', handleGroupId: string }> } | null }, unit: { __typename: 'ComplaintUnit', unitId: number, name: string, shortName: string, station: { __typename: 'Station', stationId: number, name: string, shortName: string } } } | { __typename: 'ComplaintAccessDenied', message?: string | null, complaintId: number } | { __typename: 'ComplaintIsAlreadyFir', message?: string | null, complaintId: number } | { __typename: 'ComplaintNotFound', message?: string | null, complaintId: number } | { __typename: 'FieldDateRangeValidationFailed', message?: string | null, fieldId: string } | { __typename: 'FirAlreadyExistsWithGivenDetails', message?: string | null, complaintId: number } | { __typename: 'FirDraftAlreadyExists', message?: string | null, complaintId: number } | { __typename: 'InvalidFirNumber', message?: string | null, firNumber: string } | { __typename: 'InvalidMultiSelectFieldResponse', message?: string | null, fieldId: string, response: string } };


export const ConvertToFirDocument = gql`
    mutation ConvertToFir($params: ConvertToFirParams!) {
  convertToFir(params: $params) {
    ... on Complaint {
      ...Complaint
    }
    ... on ComplaintNotFound {
      message
      complaintId
    }
    ... on ComplaintAccessDenied {
      message
      complaintId
    }
    ... on ComplaintIsAlreadyFir {
      message
      complaintId
    }
    ... on FirAlreadyExistsWithGivenDetails {
      message
      complaintId
    }
    ... on InvalidMultiSelectFieldResponse {
      message
      fieldId
      response
    }
    ... on FirDraftAlreadyExists {
      message
      complaintId
    }
    ... on InvalidFirNumber {
      message
      firNumber
    }
    ... on FieldDateRangeValidationFailed {
      message
      fieldId
    }
  }
}
    ${ComplaintFragmentDoc}`;
export type ConvertToFirMutationFn = Apollo.MutationFunction<ConvertToFirMutation, ConvertToFirMutationVariables>;
export type ConvertToFirMutationResult = Apollo.MutationResult<ConvertToFirMutation>;
export type ConvertToFirMutationOptions = Apollo.BaseMutationOptions<ConvertToFirMutation, ConvertToFirMutationVariables>;